import { css } from '@emotion/react'
import omit from 'lodash/omit'

import Colors from '../theme/Colors'
import { normalButtonStyle, largeButtonStyle, stretchButtonStyle } from './Button'
import ClickArea from './ClickArea'

export default function Link(
  props: React.ComponentProps<typeof ClickArea> & {
    size?: 'button' | 'large' | 'stretch'
    color: 'teal' | 'red' | 'orange' | 'light'
  },
) {
  const passThroughProps = omit(props, 'size', 'color')

  return (
    <ClickArea
      {...passThroughProps}
      css={[
        css`
          :disabled {
            color: ${Colors.Gray400};
          }
        `,
        props.size === 'button' && normalButtonStyle,
        props.size === 'large' && largeButtonStyle,
        props.size === 'stretch' && stretchButtonStyle,
        (props.color === 'teal' || !props.color) && tealLinkStyle,
        props.color === 'red' && redLinkStyle,
        props.color === 'orange' && orangeLinkStyle,
        props.color === 'light' && lightLinkStyle,
      ]}
    />
  )
}

const tealLinkStyle = css`
  color: ${Colors.Teal400};

  :not(:disabled) {
    &:hover {
      color: ${Colors.Teal500};
    }

    &:active {
      color: ${Colors.Teal600};
    }
  }
`

const redLinkStyle = css`
  color: ${Colors.Red400};

  :not(:disabled) {
    &:hover {
      color: ${Colors.Red500};
    }

    &:active {
      color: ${Colors.Red600};
    }
  }
`

const orangeLinkStyle = css`
  color: ${Colors.Amber400};

  :not(:disabled) {
    &:hover {
      color: ${Colors.Amber500};
    }

    &:active {
      color: ${Colors.Amber600};
    }
  }
`

const lightLinkStyle = css`
  color: ${Colors.White};
  font-weight: 600;

  :not(:disabled) {
    &:hover {
      text-decoration: underline;
      color: ${Colors.White};
    }

    &:active {
      text-decoration: underline;
      color: ${Colors.White};
    }
  }
`
